import { Injectable } from '@angular/core'
import {
  CanActivate, Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  CanActivateChild,
} from '@angular/router'
import { NuclearObservable } from '../nuclear-observable'
import {Account} from '../types'
import {customerGetters} from '../stores/customer-store'
import { AccountActions } from '../actions/account-actions'
import { present } from '../utils'

@Injectable()
export class NotSetupGuard implements CanActivate, CanActivateChild {
  account: Account;

  constructor(private router: Router, private accountActions: AccountActions) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    let url: string = state.url
    return this.checkNotSetup()
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return this.canActivate(route, state)
  }

  checkNotSetup(url?: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.account = NuclearObservable.currentValue<Account>(customerGetters.account, { toJS: true })
      if (present(this.account)) {
        if (!this.account.fullySetUp) {
          resolve(true)
        } else {
          if (window) window.location.pathname = '/'
          resolve(false)
        }
      }


      this.accountActions.loadAccount().then(() => {
        this.account = NuclearObservable.currentValue<Account>(customerGetters.account, { toJS: true })
        if (present(this.account)) {
          if (!this.account.fullySetUp) {
            resolve(true)
          } else {
            if (window) window.location.pathname = '/'
            resolve(false)
          }
        } else {
          resolve(true) // Should this necessarily let them through if there is no loaded account?
        }
      })
    })
  }

}
